export interface UserRole {
	id: number;
	name: string;
}

export const TABU_OWNER: UserRole = {
	id: 0x1,
	name: "Tabu User - Owner",
};
export const ACCESS_PROFILE: UserRole = {
	id: 0x2,
	name: "Access User Profile screen",
};
export const UPDATE_PROFILE: UserRole = {
	id: 0x04,
	name: "Update User Profile",
};
export const UPDATE_PROFILE_PIC: UserRole = {
	id: 0x08,
	name: "Update User Profile Pic",
};
export const TAQYIMEE_USER: UserRole = {
	id: 0x10,
	name: "Taqyimee User",
};
export const TAQYIMEE_OFFICE_ADMIN: UserRole = {
	id: 0x20,
	name: "Taqyimee Office Admin",
};
export const TAQYIMEE_OFFICE_VALUATOR: UserRole = {
	id: 0x40,
	name: "Taqyimee Office Valuator",
};
export const RDC_USER: UserRole = {
	id: 0x80,
	name: "RDC User",
};
export const EJARI_USER: UserRole = {
	id: 0x100,
	name: "RDC User",
};
export const SIMSARI_USER: UserRole = {
	id: 0x200,
	name: "Simsari User",
};
export const SSO_USER: UserRole = {
	id: 0x800,
	name: "SSO User",
};
